// FX targets (lead decision L16, the M7 × M10 contract): the DOM places coin flights and "+$" floaters fly
// to. The UI shell (M7) registers a getter of each element's current client rect; the FX layer (M10)
// resolves it when a flight starts. A getter returns null while its element is not on screen (the counter
// in Build mode, the tab bar before u04), so a flight can fall back to another target.
export type FxTargetId = 'hudCash' | 'hudRate' | 'counter' | 'goalChip' | 'mergeAll' | 'shopTab';

const targets: Partial<Record<FxTargetId, () => DOMRect | null>> = {};

/** Registers (or replaces) the rect getter of target `id`. */
export function registerFxTarget(id: FxTargetId, getRect: () => DOMRect | null): void {
  targets[id] = getRect;
}

/** The client rect of target `id` now, or null (not registered / not on screen). */
export function fxTarget(id: FxTargetId): DOMRect | null {
  const get = targets[id];
  return get ? get() : null;
}
